/* ============================================================
 * N36 native-cart glue (2026-08-15) — TYPOGRAPHIC GAUGE
 * No illustration. One hairline track, two labeled tier ticks
 * ($150 flat rate, $250 free), a big serif dollar amount that
 * counts down live, and nearest-reward messaging. Delight comes
 * from motion and type, not pictures.
 * Owns: body.n36-native-cart class + the bar.
 * HARD GATE: inert unless window.N36_NATIVE_CART === true.
 * ============================================================ */
(function () {
  if (window.N36_NATIVE_CART !== true) return;
  if (window.__n36FsbGlue) return;
  window.__n36FsbGlue = 1;

  /* Tier config. `flat` = the $150 discounted-flat-rate rung, `free` = $250.
     ACTIVATED 2026-09-03 for the flat-rate launch (rates live in Shopify
     shipping settings the same window). The bar never promises a rate
     checkout won't honor, so this flip ships together with the rate cutover. */
  var TIERS = {
    flat: 15000, /* $150 discounted flat rate — LIVE with the rate cutover */
    free: 25000
  };

  /* Burger promo rung (2026-09-16 -> 09-22): a $200 tier for the free hamburger
     pack, window-gated so the bar reverts to flat/free after the promo. Same
     window as the cart sweeper (n36-burger-gift.liquid) + the checkout guard. */
  var BURGER = { cents: 20000,
    start: Date.UTC(2026, 8, 16, 7, 0, 0),   /* 3:00 AM ET 2026-09-16 */
    end:   Date.UTC(2026, 8, 24, 4, 59, 0) }; /* 11:59 PM CT 2026-09-23 (extended +1 day, Asher 9/20) */
  function burgerOn() { var n = Date.now(); return n >= BURGER.start && n < BURGER.end; }

  /* Link to the flat-rate map/explainer. Set to the real URL at launch; while
     empty, no link renders (never ship a dead link on the live cart). */
  var MAP_URL = '/pages/shipping-rates';

  var REDUCED = false;
  try {
    REDUCED = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  } catch (e) {}

  /* a plain measurement mark ON the bar at a threshold's % */
  function barMark(cents) {
    var t = document.createElement('span');
    t.className = 'n36-fsb__gtick';
    t.setAttribute('data-cents', String(cents));
    t.style.left = ((cents / TIERS.free) * 100).toFixed(1) + '%';
    return t;
  }

  /* a threshold LABEL that sits BELOW the bar (price + name). Mid labels are
     centered on their % point; the end label ($250) pins to the right end. */
  function scaleTk(cents, name, atEnd) {
    var tk = document.createElement('span');
    tk.className = 'n36-fsb__tk ' + (atEnd ? 'n36-fsb__tk--end' : 'n36-fsb__tk--mid');
    tk.setAttribute('data-cents', String(cents));
    if (!atEnd) tk.style.left = ((cents / TIERS.free) * 100).toFixed(1) + '%';
    var amt = document.createElement('span');
    amt.className = 'amt';
    amt.textContent = '$' + Math.round(cents / 100);
    var nm = document.createElement('span');
    nm.className = 'nm';
    nm.textContent = name;
    tk.appendChild(amt);
    tk.appendChild(nm);
    return tk;
  }

  function build() {
    var d = document.createElement('div');
    d.className = 'n36-fsb n36-fsb--gauge' + (burgerOn() ? ' n36-fsb--burger' : '');
    d.setAttribute('role', 'status');
    d.setAttribute('aria-live', 'polite');
    d.style.display = 'block';
    /* top row: just the countdown message, full width (no more $250 crammed
       beside it or a $150 label colliding from the middle). */
    var head = document.createElement('span');
    head.className = 'n36-fsb__head';
    var msg = document.createElement('span');
    msg.className = 'n36-fsb__msg';
    msg.textContent = 'Loading your box';
    head.appendChild(msg);
    d.appendChild(head);
    var gauge = document.createElement('span');
    gauge.className = 'n36-fsb__gauge';
    var line = document.createElement('span');
    line.className = 'n36-fsb__gline';
    var fill = document.createElement('span');
    fill.className = 'n36-fsb__gfill';
    gauge.appendChild(line);
    gauge.appendChild(fill);
    if (TIERS.flat) gauge.appendChild(barMark(TIERS.flat));
    if (burgerOn()) gauge.appendChild(barMark(BURGER.cents));
    d.appendChild(gauge);
    /* threshold labels BELOW the bar; each mutes to a check once passed. */
    var scale = document.createElement('span');
    scale.className = 'n36-fsb__scale';
    if (TIERS.flat) scale.appendChild(scaleTk(TIERS.flat, 'Discounted flat rate', false));
    if (burgerOn()) scale.appendChild(scaleTk(BURGER.cents, 'Free burgers', false));
    scale.appendChild(scaleTk(TIERS.free, 'Free shipping', true));
    d.appendChild(scale);
    return d;
  }

  /* -------- the countdown: tween the big number -------- */
  var shownAmt = null; /* dollars currently displayed */
  var rafId = null;
  function renderAmt(el, dollarsVal) {
    el.textContent = '$' + Math.max(0, Math.round(dollarsVal));
  }
  function tweenAmt(el, toDollars) {
    if (rafId) cancelAnimationFrame(rafId);
    if (REDUCED || shownAmt == null) {
      shownAmt = toDollars;
      renderAmt(el, toDollars);
      return;
    }
    var from = shownAmt, start = null, DUR = 450;
    function step(ts) {
      if (start == null) start = ts;
      var p = Math.min(1, (ts - start) / DUR);
      var eased = 1 - Math.pow(1 - p, 3); /* easeOutCubic */
      renderAmt(el, from + (toDollars - from) * eased);
      if (p < 1) { rafId = requestAnimationFrame(step); }
      else { shownAmt = toDollars; rafId = null; }
    }
    rafId = requestAnimationFrame(step);
  }

  /* the shipping phrase in the message doubles as the link to the rate map
     (the theme's global modal intercepts /pages/shipping-rates clicks). */
  function mapEl(text, cls) {
    var el;
    if (MAP_URL) { el = document.createElement('a'); el.href = MAP_URL; }
    else { el = document.createElement('span'); }
    el.className = cls;
    el.textContent = text;
    return el;
  }

  function setMessage(msg, cents) {
    var mode, amtDollars = 0;
    if (cents >= TIERS.free) mode = 'free';
    else if (burgerOn() && cents >= BURGER.cents) { mode = 'mid'; amtDollars = Math.ceil((TIERS.free - cents) / 100); }
    else if (burgerOn() && cents >= TIERS.flat) { mode = 'burger'; amtDollars = Math.ceil((BURGER.cents - cents) / 100); }
    else if (TIERS.flat && cents >= TIERS.flat) { mode = 'mid'; amtDollars = Math.ceil((TIERS.free - cents) / 100); }
    else if (TIERS.flat) { mode = 'low'; amtDollars = Math.ceil((TIERS.flat - cents) / 100); }
    else { mode = 'only'; amtDollars = Math.ceil((TIERS.free - cents) / 100); }

    /* rebuild only when the sentence shape changes; tween the number */
    if (msg.getAttribute('data-mode') !== mode) {
      msg.setAttribute('data-mode', mode);
      while (msg.firstChild) msg.removeChild(msg.firstChild);
      if (mode === 'free') {
        msg.appendChild(mapEl('FREE EXPRESS SHIPPING', 'n36-fsb__goal'));
        msg.appendChild(document.createTextNode(' unlocked'));
      } else {
        var amt = document.createElement('span');
        amt.className = 'n36-fsb__amt';
        if (mode === 'mid') {
          var note = document.createElement('span');
          note.className = 'n36-fsb__note';
          note.textContent = (burgerOn() && cents >= BURGER.cents) ? 'Free burgers unlocked' : 'Discounted flat rate unlocked';
          msg.appendChild(note);
          msg.appendChild(document.createTextNode('Spend '));
          msg.appendChild(amt);
          msg.appendChild(document.createTextNode(' more for '));
          msg.appendChild(mapEl('FREE SHIPPING', 'n36-fsb__hl'));
        } else if (mode === 'burger') {
          var noteb = document.createElement('span');
          noteb.className = 'n36-fsb__note';
          noteb.textContent = 'Discounted flat rate unlocked';
          msg.appendChild(noteb);
          msg.appendChild(document.createTextNode('Spend '));
          msg.appendChild(amt);
          msg.appendChild(document.createTextNode(' more for '));
          var bhl = document.createElement('span');
          bhl.className = 'n36-fsb__hl';
          bhl.textContent = 'FREE HAMBURGERS';
          msg.appendChild(bhl);
        } else if (mode === 'low') {
          msg.appendChild(document.createTextNode("You're "));
          msg.appendChild(amt);
          msg.appendChild(document.createTextNode(' from '));
          msg.appendChild(mapEl('discounted flat rate shipping', 'n36-fsb__hl'));
        } else {
          msg.appendChild(amt);
          msg.appendChild(document.createTextNode(' more for '));
          var goal = document.createElement('span');
          goal.className = 'n36-fsb__goal';
          goal.textContent = 'FREE EXPRESS SHIPPING';
          msg.appendChild(goal);
        }
      }
      shownAmt = null; /* new sentence: no cross-sentence tween */
    }
    var amtEl = msg.querySelector('.n36-fsb__amt');
    if (amtEl) tweenAmt(amtEl, amtDollars);
    return mode === 'free';
  }

  function setState(el, cents) {
    var unlocked = false;
    var msg = el.querySelector('.n36-fsb__msg');
    if (msg) unlocked = setMessage(msg, cents);
    el.classList.toggle('n36-fsb--unlocked', unlocked);
    var fill = el.querySelector('.n36-fsb__gfill');
    if (fill) {
      var pct = Math.max(0, Math.min(100, (cents / TIERS.free) * 100));
      fill.style.width = pct.toFixed(1) + '%';
    }
    /* passed thresholds mute to a check (is-reached); the nearest UNreached
       threshold is the live goal (is-goal, oxblood). */
    var goalCents;
    if (cents < TIERS.flat) goalCents = TIERS.flat;
    else if (burgerOn() && cents < BURGER.cents) goalCents = BURGER.cents;
    else if (cents < TIERS.free) goalCents = TIERS.free;
    else goalCents = 0;
    var marks = el.querySelectorAll('[data-cents]');
    for (var i = 0; i < marks.length; i++) {
      var threshold = parseInt(marks[i].getAttribute('data-cents'), 10);
      marks[i].classList.toggle('is-reached', !isNaN(threshold) && cents >= threshold);
      marks[i].classList.toggle('is-goal', threshold === goalCents);
    }
  }

  /* The Latitude QUARTER Share ships free regardless of the $250 threshold, so
     the "$X to go for free shipping" bar is misleading — hide the bar entirely
     when the Quarter variant is in the cart (Asher 2026-08-21: "literally only
     the quarter box"; Half/Full clear $250 on their own). */
  var QUARTER_VARIANT = 50201380651255;
  var hideForQuarter = false;
  function mountAndRefresh() {
    var drawer = document.querySelector('cart-drawer');
    if (!drawer) return;
    /* empty cart: no shipping goal to show, and with no drawer header to sit
       under the bar lands at the BOTTOM of the empty-state layout — just remove
       it entirely (Asher 2026-08-21). Re-mounts the moment an item is added. */
    if (drawer.classList.contains('is-empty') || drawer.querySelector('.drawer__inner-empty')) {
      var _empty = drawer.querySelector('.n36-fsb');
      if (_empty && _empty.parentNode) _empty.parentNode.removeChild(_empty);
      return;
    }
    if (hideForQuarter) {
      var _q = drawer.querySelector('.n36-fsb');
      if (_q && _q.parentNode) _q.parentNode.removeChild(_q);
      return;
    }
    var inner = drawer.querySelector('.drawer__inner');
    if (!inner) return;
    var bar = drawer.querySelector('.n36-fsb');
    var rebuilt = false;
    if (!bar) {
      shownAmt = null; /* fresh mount: render number instantly */
      bar = build();
      var header = inner.querySelector('.drawer__header');
      if (header) header.insertAdjacentElement('afterend', bar);
      else inner.insertAdjacentElement('afterbegin', bar);
      rebuilt = true;
    }
    if (lastTotal != null) setState(bar, lastTotal);
    /* a rebuild means Dawn just re-rendered after SOME mutation; never
       trust the cached total across that boundary — re-fetch the truth */
    if (rebuilt || lastTotal == null) refreshTotal();
  }

  var lastTotal = null;
  var fetching = false;
  var refetchQueued = false;
  /* totalGen: bumped whenever an authoritative total arrives via the
     n36cart:updated event; a /cart.js response that started before that
     bump is stale and must not overwrite the fresher total (race: add
     lands while the mount-time fetch is still in flight). */
  var totalGen = 0;
  function refreshTotal() {
    if (fetching) { refetchQueued = true; return; }
    fetching = true;
    var myGen = totalGen;
    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (c) {
        fetching = false;
        if (myGen === totalGen) {
          lastTotal = c.total_price;
          hideForQuarter = (c.items || []).some(function (i) { return i.variant_id === QUARTER_VARIANT; });
          var bar = document.querySelector('cart-drawer .n36-fsb');
          if (hideForQuarter) { if (bar && bar.parentNode) bar.parentNode.removeChild(bar); }
          else if (bar) setState(bar, lastTotal);
        }
        if (refetchQueued) { refetchQueued = false; refreshTotal(); }
      })
      .catch(function () {
        fetching = false;
        if (refetchQueued) { refetchQueued = false; refreshTotal(); }
      });
  }

  document.addEventListener('n36cart:updated', function (e) {
    if (e && e.detail && e.detail.cart && typeof e.detail.cart.total_price === 'number') {
      totalGen++;
      lastTotal = e.detail.cart.total_price;
      if (e.detail.cart.items) hideForQuarter = e.detail.cart.items.some(function (i) { return i.variant_id === QUARTER_VARIANT; });
      var bar = document.querySelector('cart-drawer .n36-fsb');
      if (hideForQuarter) { if (bar && bar.parentNode) bar.parentNode.removeChild(bar); }
      else if (bar) setState(bar, lastTotal);
      else mountAndRefresh();
    } else {
      refreshTotal();
    }
  });

  var mo, t;
  function arm() {
    try { document.body.classList.add('n36-native-cart'); } catch (e) {}
    var drawer = document.querySelector('cart-drawer');
    if (drawer && !mo) {
      mo = new MutationObserver(function () {
        clearTimeout(t);
        t = setTimeout(mountAndRefresh, 50);
      });
      mo.observe(drawer, { childList: true, subtree: true });
    }
    mountAndRefresh();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', arm);
  else arm();
})();
